import React from 'react'
import classnames from 'classnames'
import NumberFormat from 'react-number-format'

const NumberInput = (props) => {
  const { 
    label, 
    specialOnChange, 
    specialOnFocus, 
    input, 
    require, 
    editable, 
    decimalScale=2, 
    fixedDecimalScale=false, 
    inputStyle={},
    textAlignLeft, 
    thousandSeparator=true, 
    allowNegative=true, 
    suffix, 
    prefix, 
    marginLess,
    placeholder, 
    noBorder=false,
    style, 
    formatValue=null,
    meta: { touched, error } 
  } = props

  return (
    <div className={classnames('fieldRow', { marginLess })} style={{ ...style }}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ui input ${touched && error ? 'error' : ''} ${editable!==false?'editableNumberInput':''} ${noBorder?'inputNoBorder':''}`}>
        <NumberFormat
          name={input.name}
          defaultValue={0}
          value={input.value}
          fixedDecimalScale={fixedDecimalScale}
          thousandSeparator={thousandSeparator}
          decimalScale={decimalScale}
          allowNegative={allowNegative}
          suffix={suffix !== undefined ? suffix : ''}
          prefix={prefix !== undefined ? prefix : ''}
          disabled={editable === false}
          placeholder={placeholder}
          format={formatValue}
          onValueChange={values => {
            input.onChange(values.value)
            if (specialOnChange) {
              specialOnChange(values.value)
            }
          }}
          onFocus={event => {
            event.target.select()
            if (specialOnFocus) {
              specialOnFocus()
            }
          }}
          style={{ textAlign: textAlignLeft?'':'right', ...inputStyle}}
        />
      </div>
    </div>
  )
}

export default NumberInput